import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 98px;
  height: 68px;
  border-radius: 4px;
  background: #f5f5f5;
`;

export const StatsScore = styled(Typography)`
  text-align: center;
  font-family: "NotoSans-Bold";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const StatsTitle = styled(Typography)`
  font-family: "NotoSans-Bold";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
